import { render, staticRenderFns } from "./select.vue?vue&type=template&id=a2dd3c04&scoped=true"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"
import style0 from "./select.vue?vue&type=style&index=0&id=a2dd3c04&prod&lang=less&scoped=true"
import style1 from "./select.vue?vue&type=style&index=1&id=a2dd3c04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dd3c04",
  null
  
)

export default component.exports